import * as ActionTypes from '../Collapse';

export function collapseAllGroups(data) {
    return {type: ActionTypes.COLLAPSE_ALL_GROUPS, data, section: 'live'};
}

export function collapseAllMatches(data) {
    return {type: ActionTypes.COLLAPSE_ALL_MATCHES, data, section: 'live'};
}



// WEBPACK FOOTER //
// ./js/actions/creators/Collapse.js